<template>
  <div>
    <div class="contents">
      <div class="ceping">启程志愿测评中心</div>
      <div class="jianjie">目前使用人数第一的测评中心</div>
      <div class="juti">
        <div class="jutis" @click="type=1" :class="[type==1?'select':'']">
          <img src="../../assets/ics.png" class="icon" v-if="type==2" alt="">
          <img src="../../assets/ico.png" class="icon" v-if="type==1" alt="">
          <div class="ceping01">MBTI职业性格测试</div>
          <div class="ceping02">专业版</div>
          <div class="ceping03">近30天测评</div>
          <div class="ceping03" style="margin-top: 5px;">22W人</div>
        </div>
        <div class="jutis" @click="type=2" :class="[type==2?'select':'']" style="margin-left: 70px;">
          <img src="../../assets/ics.png" class="icon" v-if="type==1" alt="">
          <img src="../../assets/ico.png" class="icon" v-if="type==2" alt="">
          <div class="ceping01">霍兰德职业兴趣测试</div>
          <div class="ceping02">专业版</div>
          <div class="ceping03">近30天测评</div>
          <div class="ceping03" style="margin-top: 5px;">22W人</div>
        </div>
      </div>
      <div class="sucess" @click="kaishice">开始测试</div>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex"
  import { lookHuolan,lookDetailCengping } from "@/api/gw/ceping.js"
  export default {
    computed: {
      ...mapGetters(['isLogin', "userinfo"]),
    },
    data() {
      return {
        type: 1, //1MBTI
      }
    },
    mounted() {
      console.log("login10")
      this.$store.dispatch("getUserInfo");
      lookDetailCengping({}).then(res=>{
        if(res.data){
          lookHuolan({}).then(res=>{
            if(res.data){
              this.$router.push({
                path:"/home?type=4&activeName=1"
              })
            }
          })
        }
      })
    },
    methods: {
      kaishice() {
        
      console.log("login11")
        this.$store.dispatch("getUserInfo").then(res => {
          
          this.$store.dispatch("isVipLogin").then(()=>{
            if(res.role==2||res.role==3){
              console.log("是vip");
              //此时需要再次请求  是否已经有测评
              if(this.type==1){
                  lookDetailCengping({}).then(res=>{
                    console.log("查看测评结果",res);
                    if(res.data){
                        this.$confirm('您已有测评结果, 是否查看?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                          }).then(()=>{
                                this.$router.push({
                                  path:"/home?type=4&activeName=1"
                                })
                          })
                    }else{
                      this.$router.push({
                        path:"/AppraisalMBTI"
                      })
                    }
                  })
              }else{
                  lookHuolan({}).then(res=>{
                    console.log("查看测评结果",res);
                    if(res.data){
                        this.$confirm('您已有测评结果, 是否查看?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                          }).then(()=>{
                                this.$router.push({
                                  path:"/home?type=4&activeName=2"
                                })
                          })
                    }else{
                      this.$router.push({
                        path:"/Hollander"
                      })
                    }
                  })
              }
            }
          })
          // if (res.role != 2 && res.role != 3) {
          //   this.$confirm('此测评为VIP专属功能，开通VIP才可以使用?', '提示', {
          //     confirmButtonText: '购买VIP',
          //     cancelButtonText: '取消',
          //     type: 'warning'
          //   }).then(() => {
          //     this.$router.push({
          //       path: "/Home",
          //       query: {
          //         type: 3
          //       }
          //     })
          //   })
          // }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .sucess {
    cursor: pointer;
    width: 600px;
    height: 3rem;
    border-radius: 3rem;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 3rem;
    background: linear-gradient(to left, #3f7cff, #87abf7);
    margin: 3rem 0%;
    box-shadow: 0 0 8px #ddd;
  }

  .select {
    background: linear-gradient(to left, #3f7cff, #87abf7) !important;

    .ceping01,
    .ceping02,
    .ceping03 {
      color: #fff !important;
    }
  }

  .ceping03 {
    color: #999;
    margin-top: 30px;
    font-size: 15px;
  }

  .ceping02 {
    font-size: 20px;
    margin-top: 30px;
  }

  .ceping01 {
    font-size: 22px;
    font-weight: bold;
    margin-top: 15px;
  }

  .icon {
    width: 64px;
    height: 64px;
  }

  .juti {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;

    .jutis {
      width: 260px;
      height: 300px;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0 0 8px #ddd;
      margin-right: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
    }
  }

  .contents {
    .jianjie {
      color: #666;
      font-size: 16px;
      margin-top: 20px;
    }

    .ceping {
      font-size: 32px;
      font-weight: bold;
      color: #515151;
      margin-top: 30px;
    }

    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/views/appraisal/index.vue